module.exports = {
    props: ['user'],
};
